import React from 'react';
import { Route } from 'react-router-dom';
import Case from './Case';
import Index from './Index/index';
import Personal from './Personal';
import Service from './Service';
import Report from './Report';
import ContactUs from './ContactUs';
import Pay from './Pay';

const routers = [
  <Route key="/case" path="*/case" component={Case} />, // 案例
  <Route key="/personal" path="*/personal" component={Personal} />, // 个人中心
  <Route key="/service" path="*/service" component={Service} />, // 服务
  <Route key="/report" path="*/report" component={Report} />, // 报告中心
  <Route key="/contactus" path="*/contactus" component={ContactUs} />, // 联系我们
  <Route key="/pay" path="*/pay" component={Pay} />,
  <Route key="/" path="*/" component={Index} />, // 首页
];

export default routers;
